import React, { useEffect, useState } from "react";
import { api } from "../api";
import { fmtVND, fmtCurrency, fmtDateTime } from "../lib/format";
import StatusChip from "../components/StatusChip";

export default function AdminPayouts() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.adminAll().then((r) => {
      setRows(r);
      setLoading(false);
    });
  }, []);

  return (
    <div className="space-y-6">
      <header>
        <h1 className="font-display text-3xl font-bold text-slate-900">All Payouts</h1>
        <p className="text-sm text-slate-500 mt-1">Ops view across all customers.</p>
      </header>

      <div className="rounded-2xl border border-slate-200 bg-white overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full min-w-[720px]">
            <thead className="bg-slate-50 text-[11px] uppercase tracking-widest text-slate-500">
              <tr>
                <th className="px-4 py-3 text-left font-semibold">Created</th>
                <th className="px-4 py-3 text-left font-semibold">Destination</th>
                <th className="px-4 py-3 text-left font-semibold">Rail Ref</th>
                <th className="px-4 py-3 text-right font-semibold">Gross</th>
                <th className="px-4 py-3 text-right font-semibold">Net</th>
                <th className="px-4 py-3 text-left font-semibold">Status</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {loading && (
                <tr>
                  <td colSpan={6} className="px-4 py-8 text-center text-sm text-slate-500">
                    Loading…
                  </td>
                </tr>
              )}
              {!loading && rows.length === 0 && (
                <tr>
                  <td colSpan={6} className="px-4 py-8 text-center text-sm text-slate-500">
                    No payouts yet.
                  </td>
                </tr>
              )}
              {rows.map((p) => (
                <tr
                  key={p.id}
                  data-testid={`admin-payout-row-${p.id}`}
                  className="hover:bg-slate-50 transition-colors"
                >
                  <td className="px-4 py-3 text-xs text-slate-500 whitespace-nowrap">
                    {fmtDateTime(p.created_at)}
                  </td>
                  <td className="px-4 py-3 text-sm">
                    <p className="font-medium text-slate-900">
                      {p.destination_snapshot?.bank_name}
                    </p>
                    <p className="text-xs text-slate-500">
                      {p.destination_snapshot?.account_holder}
                    </p>
                  </td>
                  <td className="px-4 py-3">
                    {p.rail_reference_id ? (
                      <code className="rounded bg-slate-100 px-1.5 py-0.5 font-mono text-[10px] text-slate-700">
                        {p.rail_reference_id}
                      </code>
                    ) : (
                      <span className="text-xs text-slate-400">—</span>
                    )}
                  </td>
                  <td className="px-4 py-3 text-right text-sm font-semibold text-slate-900 tabular-nums">
                    {fmtVND(p.amount_vnd)}
                  </td>
                  <td className="px-4 py-3 text-right text-sm font-semibold text-teal-700 tabular-nums">
                    {fmtCurrency(p.net_amount, p.payout_currency)}
                  </td>
                  <td className="px-4 py-3">
                    <StatusChip status={p.status} />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
